import {useTheme} from "@mui/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import MuiDialog from "@mui/material/Dialog";
import React from "react";

export const Dialog = React.forwardRef((props, ref) => {
  const theme = useTheme();
  const {
    fullScreen = useMediaQuery(theme.breakpoints.down('sm')),
    maxWidth = 'md',
    children,
    ...other
  } = props;

  return (
    <MuiDialog
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      ref={ref}
      {...other}
    >
      {children}
    </MuiDialog>
  );
});
